import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React from "react";

import LogoUrl from './../../assets/img/logo.svg';
import LogoUrlNegative from './../../assets/img/logo_negative.svg';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faXmark} from "@fortawesome/pro-light-svg-icons";

const Header = (props) => {
	if (!props.general) {
		return null;
	}
	let headerBtn = props.general.header?.btn;
	let transHeader = props.headerStyle === 1 && !props.custom.scrolled;
	let fixedHeader = props.headerStyle === 1;
	let solidHeader = props.headerStyle === 2;

	return <header className={"site-header"  + (props.custom.scrolled ? " pinned" : "") + (transHeader ? " transparent" : "") + (fixedHeader ? " fixed" : "")  + (solidHeader ? " solid" : "")}>
		<div className="container">
			<div className="row no-gutters align-items-center">
				<div className="col-lg col-logo">

					<Link to="/" className="logo">
						<img src={LogoUrl} className="default" alt={props.general.title} />
						<img src={LogoUrlNegative} className="negative" alt={props.general.title} />
					</Link>

					<button onClick={props.toggleMenu} className={"menu-toggle " + (props.menu.menu_toggled ? " toggled" : "")}>
						<FontAwesomeIcon className={"icon"} icon={props.menu.menu_toggled ? faXmark : faBars} />
					</button>

				</div>
				<div className={"col-lg col-nav" + (props.menu.menu_toggled ? " open" : "")}>
					{props.menu.menus.main_menu &&
						<ul className="nav">
							{props.menu.menus.main_menu.items.map((item, i) => {
								if (item.parent === 0) {
									let children = props.menu.menus.main_menu.items.filter(it => it.parent === item.id);
									if (children.length > 0) {

										let toggled = (props.custom.submenu_id === item.id);

										return <li key={item.id} className={"nav-item has-children" + (toggled ? " open" : "")}>
											<button onClick={props.toggleSubMenu.bind(null, (toggled ? -1 : item.id))} className="nav-link">{item.title}</button>

											<div className="sub-menu">
												<div className="sub-menu-inner">
													<ul className="nav nav-sub">
														{children.map((subitem, i) => {
															return <li key={i} className={"nav-item" + (subitem.class ? " " + subitem.class : "")}>
																<SmartLink className="nav-link" url={subitem.url} target={subitem.target}>{subitem.title}</SmartLink>
															</li>
														})}
													</ul>
												</div>
											</div>

										</li>

									} else {

										return <li key={item.id} className="nav-item">
											<SmartLink activeClassName="current" className="nav-link" url={item.url} target={item.target}>{item.title}</SmartLink>
										</li>
									}
								}
							})}


							{headerBtn &&
								<li className="nav-item nav-item--aside">
									<SmartLink url={headerBtn.url} className={"button button-sm" + (transHeader ? " button-light-outline" : "")}>{headerBtn.title}</SmartLink>
								</li>
							}
						</ul>
					}
				</div>
			</div>
		</div>



	</header>
};
export default connect(
	state => {
		return {
			menu: state.menuState,
			general: state.generalState.general,
			headerStyle: state.pageState.page?.headerStyle,
			custom: state.customState
		}
	},
	(dispatch) => {
		return {
			toggleMenu: () => {
				dispatch({
					type: 'MENU_TOGGLED'
				})
			},
			toggleSubMenu: (id, e) => {

				e.preventDefault();
				dispatch({
					type: 'SUBMENU_TOGGLED',
					id: id
				})
			},
		}
	}
)(Header);
